import React, { PropsWithChildren } from 'react';

import { formatUsd } from 'helpers';

import { TABLE_CELL_FONT_SIZE } from './constants';
import Layout, { Props as LayoutProps } from '../Layout';
import Text from '../Text';

interface Props extends LayoutProps {
  value?: number | null;
  cents?: boolean;
}

const MoneyCell: React.FC<PropsWithChildren<Props>> = ({ value, cents, children, ...props }) => {
  return (
    <Layout flexGrow={1} padding={12} justify="flex-end" __style={{ textAlign: 'right' }} {...props}>
      <Text size={TABLE_CELL_FONT_SIZE} align="right" __style={{ textAlign: 'right' }}>
        {typeof value === 'number' ? formatUsd(value, cents) : ''}
      </Text>
      {children}
    </Layout>
  );
};

export default MoneyCell;
